/**
 * Reset the document to the top of the page.
 * Covers window, documentElement/body (iOS), #root, and the main app shell
 * in case overflow-x-hidden made one of them the scroll container.
 */
export function scrollPageToTop(targetWindow) {
  const win = targetWindow || (typeof window !== 'undefined' ? window : null);
  if (!win) return false;

  if (typeof win.scrollTo === 'function') {
    try {
      win.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch {
      win.scrollTo(0, 0);
    }
  }

  const doc = win.document;
  if (doc?.documentElement) {
    doc.documentElement.scrollTop = 0;
    doc.documentElement.scrollLeft = 0;
  }
  if (doc?.body) {
    doc.body.scrollTop = 0;
    doc.body.scrollLeft = 0;
  }

  const root = typeof doc?.getElementById === 'function' ? doc.getElementById('root') : null;
  if (root) {
    root.scrollTop = 0;
    root.scrollLeft = 0;
  }

  const shell = typeof doc?.querySelector === 'function'
    ? doc.querySelector('.rentalyzer-main-with-docks')
    : null;
  if (shell) {
    shell.scrollTop = 0;
    shell.scrollLeft = 0;
  }

  return true;
}

/**
 * Scroll immediately and again after layout so a newly mounted screen
 * does not keep the previous screen's offset.
 */
export function scheduleScrollPageToTop(targetWindow) {
  scrollPageToTop(targetWindow);
  const win = targetWindow || (typeof window !== 'undefined' ? window : null);
  if (!win || typeof win.requestAnimationFrame !== 'function') return 0;
  return win.requestAnimationFrame(() => {
    scrollPageToTop(targetWindow);
  });
}
